export const selectSidebarIsOpen = state => state.getIn(['sidebar', 'isOpen']);
